import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { FormSubmissionsComponent } from '../../../pages/settings/form-submissions/form-submissions.component';
import { IFormSubmissionsDialogData } from '../../../pages/settings/form-submissions/form-submissions.interface';

@Component({
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, NgIf, FormSubmissionsComponent],
  selector: 'app-form-submission-dialog',
  standalone: true,
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <app-form-submissions
        [hideFilterCard]="true"
        [dashboardId]="data.dashboardId"
        [widgetId]="data.widgetId"
        [formId]="data.formId"
        [advancedFilters]="data.advancedFilters"
      ></app-form-submissions>
    </div>
    <div mat-dialog-actions align="end">
      <button *ngIf="data.closeButtonText" matButton="tonal" (click)="onCancel()">{{ data.closeButtonText }}</button>
    </div>
  `,
})
export class FormSubmissionsDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<FormSubmissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: IFormSubmissionsDialogData,
  ) {}

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
